import { StyleSheet, Dimensions } from 'react-native';

import { Fonts } from '../Themes';

const { height: ScreenHeight } = Dimensions.get('window');

export default StyleSheet.create({
  containerStyle: theme => ({
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.colors.backgroundColorSix,
  }),
  lottieViewStyle: {
    height: ScreenHeight / 4.9,
    width: ScreenHeight / 4.9,
  },
  titleStyle: theme => ({
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 29.1,
    marginTop: 22,
    color: theme.colors.headerTitleColor,
  }),
  subTitleStyle: theme => ({
    fontSize: 16.6,
    marginTop: 7,
    color: theme.colors.headerTitleColor,
  }),
});
